import React from 'react';

/**
 * Hooks
 */
import { useTranslation } from 'react-i18next';
import { useNetworkState } from '@uidotdev/usehooks';

/**
 * MUI Components
 */
import { Snackbar, Alert } from '@mui/material';

const ConnectionStatus = ({ children }) => {
    const { t } = useTranslation();
    const networkState = useNetworkState();

    return (
        <>
            <Snackbar
                open={!networkState.online}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity="error">
                    {t('You are offline, please check your internet connection')}
                </Alert>
            </Snackbar>
            {children}
        </>
    );
};

export default ConnectionStatus;